import Autopilot from '@/pages/Autopilot';
import AutopilotFollowup from '@/pages/AutopilotFollowup';
import AutopilotHumanHandover from '@/pages/AutopilotHumanHandover';
import AutopilotSettings from '@/pages/AutopilotSettings';
import AutopilotSpamDetection from '@/pages/AutopilotSpamDetection';
import AutopilotTagging from '@/pages/AutopilotTagging';
import CalendlyCallback from '@/pages/CalendlyCallback';
import Contacts from '@/pages/Contacts';
import CreateWorkflowPage from '@/pages/CreateWorkflowPage';
import DetailsSubmit from '@/pages/DetailsSubmit';
import ForgotPassword from '@/pages/ForgotPassword';
import GHLCallback from '@/pages/GHLCallback';
import Inbox from '@/pages/Inbox';
import InstagramDirectCallback from '@/pages/InstagramDirectCallback';
import InstagramSelectPage from '@/pages/InstagramSelectPage';
import Integrations from '@/pages/Integrations';
import LinkedInCallback from '@/pages/LinkedInCallback';
import Login from '@/pages/Login';
import OnboardingChannel from '@/pages/OnboardingChannel';
import OnboardingSetup from '@/pages/OnboardingSetup';
import OpensLogin from '@/pages/opens/OpensLogin';
import Reports from '@/pages/Reports';
import ResetPassword from '@/pages/ResetPassword';
import Settings from '@/pages/Settings';
import CalendlySettings from '@/pages/settings/CalendlySettings';
import ElevenLabsSettings from '@/pages/settings/ElevenLabsSettings';
import GHLSettings from '@/pages/settings/GHLSettings';
import IntegrationsList from '@/pages/settings/IntegrationsList';
import OnceHubSettings from '@/pages/settings/OnceHubSettings';
import OpensSettings from '@/pages/settings/OpensSettings';
import SelfServiceSettings from '@/pages/settings/SelfServiceSettings';
import TagsSettings from '@/pages/settings/TagsSettings';
import TrialCompletion from '@/pages/TrialCompletion';
import TrialPayment from '@/pages/TrialPayment';
import TrialSignUp from '@/pages/TrialSignUp';
import WorkflowRunsPage from '@/pages/WorkflowRunsPage';
import Workflows from '@/pages/Workflows';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from 'react-router-dom';

import FollowerList from '@/components/followers/FollowerList';
import FollowerNav from '@/components/followers/FollowerNav';
import FollowerStats from '@/components/followers/FollowerStats';
import SelfServiceOpens from '@/components/followers/SelfServiceOpens';
import ContactChat from '@/components/inbox/ContactChat';
import AblyLayout from '@/components/layouts/AblyLayout';
import AuthLayout from '@/components/layouts/AuthLayout';
import AutopilotLayout from '@/components/layouts/AutopilotLayout';
import NonAuthLayout from '@/components/layouts/NonAuthLayout';
import RootLayout from '@/components/layouts/RootLayout';
import SecurityLayout from '@/components/layouts/SecurityLayout';
import Navbar from '@/components/Navbar/Navbar';
import NotFound from '@/components/NotFound/NotFound';
import AgentActivityChart from '@/components/reports/AgentActivityChart';
import HighchartsComponent from '@/components/reports/Highcharts';
import Responses from '@/components/reports/Responses';
import ToolTipCharts from '@/components/reports/Tooltip';
import CannedMessages from '@/components/settings/CannedMessages';
import Copilot from '@/components/settings/Copilot';
import Email from '@/components/settings/Email';
import Instagram from '@/components/settings/Instagram';
import InstagramDirect from '@/components/settings/InstagramDirect';
import LinkedIn from '@/components/settings/LinkedIn';
import PasswordAndSecurity from '@/components/settings/PasswordAndSecurity';
import Plans from '@/components/settings/Plans';
import MobileSetup from '@/components/settings/security/MobileSetup';
import TOTPSetup from '@/components/settings/security/TOTPSetup';
import TeamMembers from '@/components/settings/TeamMembers';
import EditWorkflowPage from '@/components/workflows/edit/EditWorkflowPage';
import WorkflowListPage from '@/components/workflows/WorkflowList';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<RootLayout />}>
      <Route index element={<Navigate to='/inbox' replace />} />
      <Route element={<NonAuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='onboarding/signup' element={<TrialSignUp />} />
        <Route path='onboarding/payment' element={<TrialPayment />} />
        <Route path='onboarding/completion' element={<TrialCompletion />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        {/* <Route path='register' element={<Register />} /> */}
      </Route>
      <Route element={<AblyLayout />}>
        <Route element={<AuthLayout />}>
          <Route path='details-submit' element={<DetailsSubmit />} />
          <Route path='onboarding/setup' element={<OnboardingSetup />} />
          <Route
            path='onboarding/connect-channel'
            element={<OnboardingChannel />}
          />
          <Route
            path='onboarding/instagram/select-page'
            element={<InstagramSelectPage />}
          />
          <Route path='linkedin/callback' element={<LinkedInCallback />} />
          <Route path='calendly/callback' element={<CalendlyCallback />} />
          <Route path='ghl/callback' element={<GHLCallback />} />
          <Route
            path='instagram-direct/callback'
            element={<InstagramDirectCallback />}
          />
          <Route path='opens/login' element={<OpensLogin />} />
          <Route element={<Navbar />}>
            <Route path='inbox' element={<Inbox />}>
              <Route path=':id' element={<ContactChat />} />
            </Route>
            <Route path='contacts' element={<Contacts />} />
            <Route path='agent-activity' element={<AgentActivityChart />} />
            <Route path='reports' element={<Reports />}>
              <Route index element={<Navigate to='dashboard' replace />} />
              <Route path='dashboard' element={<HighchartsComponent />} />
              <Route path='responses' element={<Responses />} />
              <Route path='tooltip' element={<ToolTipCharts />} />
            </Route>
            <Route path='followers' element={<FollowerNav />}>
              <Route index element={<FollowerStats />} />
              <Route path='list' element={<FollowerList />} />
              <Route path='config' element={<OpensSettings />} />
              <Route path='self-service/opens' element={<SelfServiceOpens />} />
              <Route
                path='self-service/config'
                element={<SelfServiceSettings />}
              />
            </Route>
            <Route path='workflows' element={<Workflows />}>
              <Route index element={<WorkflowListPage />} />
              <Route path='runs' element={<WorkflowRunsPage />} />
              <Route path='create' element={<CreateWorkflowPage />} />
              <Route path='edit/:workflowId' element={<EditWorkflowPage />} />
            </Route>
            <Route path='revio-autopilot' element={<AutopilotLayout />}>
              <Route index element={<Autopilot />} />
              <Route
                path='human-handover'
                element={<AutopilotHumanHandover />}
              />
              <Route
                path='spam-detection'
                element={<AutopilotSpamDetection />}
              />
              <Route path='followup' element={<AutopilotFollowup />} />
              <Route path='tagging' element={<AutopilotTagging />} />
              <Route path='settings' element={<AutopilotSettings />} />
            </Route>
            <Route path='settings' element={<Settings />}>
              <Route index element={<Navigate to='team-members' replace />} />
              <Route path='team-members' element={<TeamMembers />} />
              <Route path='plans' element={<Plans />} />
              <Route path='saved-replies' element={<CannedMessages />} />
              <Route
                path='password-and-security'
                element={<PasswordAndSecurity />}
              />
              <Route path='instagram' element={<Instagram />} />
              <Route path='instagram-direct' element={<InstagramDirect />} />
              <Route path='linkedin' element={<LinkedIn />} />
              <Route path='email' element={<Email />} />
              <Route path='tags' element={<TagsSettings />} />
              <Route path='copilot' element={<Copilot />} />
              <Route path='integrations' element={<Integrations />}>
                <Route index element={<IntegrationsList />} />
                <Route path='calendly' element={<CalendlySettings />} />
                <Route path='ghl' element={<GHLSettings />} />
                <Route path='oncehub' element={<OnceHubSettings />} />
                <Route path='elevenlabs' element={<ElevenLabsSettings />} />
              </Route>
            </Route>
          </Route>
          {/* Security flows with different layout */}
          <Route element={<SecurityLayout />}>
            <Route
              path='settings/password-and-security/totp-setup'
              element={<TOTPSetup />}
            />
            <Route
              path='settings/password-and-security/mobile-setup'
              element={<MobileSetup />}
            />
          </Route>
        </Route>
      </Route>
      <Route path='*' element={<NotFound />} />
    </Route>
  )
);

export default router;
